// src/pages/premium/Mains.jsx
import React from "react";

export default function Mains() {
  return (
    <div className="container mt-5 text-center">
      <h2>📚 UPSC Mains</h2>
      <p>Mains preparation content here.</p>
    </div>
  );
}